import gql from 'graphql-tag';
import { compact } from 'lodash';

import type { ContentTaxonomy } from 'src/data/types';
import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendContentTaxonomyConnection } from 'src/types/backend';

const QUERY = gql`
  query ContentTaxonomies {
    contentTaxonomies {
      nodes {
        id
        name
        default
      }
    }
  }
`;

export const queryContentTaxonomies = async (): Promise<ContentTaxonomy[]> => {
  const result = await executeGqlQuery({
    query: QUERY,
  });

  const connection = getSingleProp<BackendContentTaxonomyConnection>(result.data);
  return cleanBackendTypedData(connection?.nodes);
};

// due to a lot of "Maybe" in BE types we need to do some cleaning to get the correct typed data for FE
const cleanBackendTypedData = (
  backendNodes: BackendContentTaxonomyConnection['nodes']
): ContentTaxonomy[] =>
  compact(backendNodes).filter((node): node is ContentTaxonomy => Boolean(node.id && node.name));
